<template class="captcha">
    <div class="form-group">
        <vue-recaptcha
          ref="recaptcha"
          @verify="onCaptchaVerified"
          @expired="onCaptchaExpired"
          size="invisible"
          :sitekey="sitekey">
        </vue-recaptcha>
    </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';

export default {
    name: "Recaptcha",
    props: {
        validate: {
            type: Number,
        },
    },

    components: {
        'vue-recaptcha': VueRecaptcha
    },

    data() {
        return {
          serverError: "",
          sitekey: process.env.VUE_APP_CAPTCHA_TOKEN,
        };
    },

    watch: {
        validate: function(){
            this.$refs.recaptcha.execute();
        }
    },

    methods: {
        onCaptchaVerified: function (recaptchaToken) {
            const self = this;
            self.$refs.recaptcha.reset();

            this.$http.post("/online-signup-service-api/v1/signup/validate-captcha", {
                recaptchaToken: recaptchaToken
            }).then((response) => {
                this.$emit('verification', response.data);
               
            }).catch((err) => {
                self.serverError = getErrorMessage(err);

                var response = {
                                    success: false,
                                    message: self.serverError
                                };

                this.$emit('verification', response);

                //helper to get a displayable message to the user
                function getErrorMessage(err) {
                    let responseBody;
                    responseBody = err.response;
                    
                    if (!responseBody) {
                        responseBody = err;
                    }
                    else {
                        responseBody = err.response.data || responseBody;
                    }

                    return responseBody.message || JSON.stringify(responseBody);
                }

            });

        },
        onCaptchaExpired: function () {
            this.$refs.recaptcha.reset();
        }
    },

}
</script>
